/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkCreateDocumentV2Dto } from '../models/work-create-document-v-2-dto';
import { WorkDocument } from '../models/work-document';
import { WorkDocumentPdfInfoDto } from '../models/work-document-pdf-info-dto';
import { WorkDocumenttypeIdentifierNameEnum } from '../models/work-documenttype-identifier-name-enum';
import { WorkMergeDocumentsDto } from '../models/work-merge-documents-dto';
import { WorkPaginatedDocumented } from '../models/work-paginated-documented';
import { WorkSaveDocumentAnnotationV2Dto } from '../models/work-save-document-annotation-v-2-dto';
import { WorkSendDocumentsByEmailV2Dto } from '../models/work-send-documents-by-email-v-2-dto';
import { WorkSplitDocumentDto } from '../models/work-split-document-dto';
import { WorkUpdateDocumentV2Dto } from '../models/work-update-document-v-2-dto';
import { WorkUpdateDocumentsMoveToProjectDto } from '../models/work-update-documents-move-to-project-dto';

@Injectable({ providedIn: 'root' })
export class WorkDocumentsV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `documentsV2ControllerFindAllPaginated()` */
  static readonly DocumentsV2ControllerFindAllPaginatedPath = '/v2/documents';

  /**
   * Required permissions: documents:read, documents:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentsV2ControllerFindAllPaginated()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentsV2ControllerFindAllPaginated$Response(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by folder query param.
     *           <p>
     *              <b>Format: </b> filter.folder={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.folder=$not:$like:John Doe&filter.folder=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.folder'?: Array<string>;

    /**
     * Filter by assignedTo query param.
     *           <p>
     *              <b>Format: </b> filter.assignedTo={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.assignedTo=$not:$like:John Doe&filter.assignedTo=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.assignedTo'?: Array<string>;

    /**
     * Filter by processingStatus query param.
     *           <p>
     *              <b>Format: </b> filter.processingStatus={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.processingStatus=$not:$like:John Doe&filter.processingStatus=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$in</li></ul>
     */
      'filter.processingStatus'?: Array<string>;

    /**
     * Filter by users.id query param.
     *           <p>
     *              <b>Format: </b> filter.users.id={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.users.id=$not:$like:John Doe&filter.users.id=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.users.id'?: Array<string>;

    /**
     * Filter by projectId query param.
     *           <p>
     *              <b>Format: </b> filter.projectId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.projectId=$not:$like:John Doe&filter.projectId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$in</li></ul>
     */
      'filter.projectId'?: Array<string>;

    /**
     * Filter by prospectId query param.
     *           <p>
     *              <b>Format: </b> filter.prospectId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.prospectId=$not:$like:John Doe&filter.prospectId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.prospectId'?: Array<string>;

    /**
     * Filter by active query param.
     *           <p>
     *              <b>Format: </b> filter.active={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.active=$not:$like:John Doe&filter.active=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.active'?: Array<string>;

    /**
     * Filter by documenttypeId query param.
     *           <p>
     *              <b>Format: </b> filter.documenttypeId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.documenttypeId=$not:$like:John Doe&filter.documenttypeId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$in</li>
     * <li>$not</li></ul>
     */
      'filter.documenttypeId'?: Array<string>;

    /**
     * Filter by documenttype.identifierName query param.
     *           <p>
     *              <b>Format: </b> filter.documenttype.identifierName={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.documenttype.identifierName=$not:$like:John Doe&filter.documenttype.identifierName=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$not</li>
     * <li>$null</li></ul>
     */
      'filter.documenttype.identifierName'?: Array<string>;

    /**
     * Filter by documentsubtypeId query param.
     *           <p>
     *              <b>Format: </b> filter.documentsubtypeId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.documentsubtypeId=$not:$like:John Doe&filter.documentsubtypeId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$null</li></ul>
     */
      'filter.documentsubtypeId'?: Array<string>;

    /**
     * Filter by statusId query param.
     *           <p>
     *              <b>Format: </b> filter.statusId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.statusId=$not:$like:John Doe&filter.statusId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$null</li>
     * <li>$not</li></ul>
     */
      'filter.statusId'?: Array<string>;

    /**
     * Filter by created query param.
     *           <p>
     *              <b>Format: </b> filter.created={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.created=$not:$like:John Doe&filter.created=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$gte</li>
     * <li>$lte</li>
     * <li>$btw</li></ul>
     */
      'filter.created'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> upload:DESC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>name</li>
     * <li>upload</li>
     * <li>created</li>
     * <li>documenttype.name</li></ul>
     */
      sortBy?: Array<'name:ASC' | 'name:DESC' | 'upload:ASC' | 'upload:DESC' | 'created:ASC' | 'created:DESC' | 'documenttype.name:ASC' | 'documenttype.name:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> name,prettyName
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>name</li>
     * <li>prettyName</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkDocument>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'folder'?: (string | Array<string>);
'assignedTo'?: (string | Array<string>);
'processingStatus'?: (string | Array<string>);
'users.id'?: (string | Array<string>);
'projectId'?: (string | Array<string>);
'prospectId'?: (string | Array<string>);
'active'?: (string | Array<string>);
'documenttypeId'?: (string | Array<string>);
'documenttype.identifierName'?: (string | Array<string>);
'documentsubtypeId'?: (string | Array<string>);
'statusId'?: (string | Array<string>);
'created'?: (string | Array<string>);
};
};
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkDocumentsV2Service.DocumentsV2ControllerFindAllPaginatedPath, 'get');
    if (params) {
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.query('filter.folder', params['filter.folder'], {});
      rb.query('filter.assignedTo', params['filter.assignedTo'], {});
      rb.query('filter.processingStatus', params['filter.processingStatus'], {});
      rb.query('filter.users.id', params['filter.users.id'], {});
      rb.query('filter.projectId', params['filter.projectId'], {});
      rb.query('filter.prospectId', params['filter.prospectId'], {});
      rb.query('filter.active', params['filter.active'], {});
      rb.query('filter.documenttypeId', params['filter.documenttypeId'], {});
      rb.query('filter.documenttype.identifierName', params['filter.documenttype.identifierName'], {});
      rb.query('filter.documentsubtypeId', params['filter.documentsubtypeId'], {});
      rb.query('filter.statusId', params['filter.statusId'], {});
      rb.query('filter.created', params['filter.created'], {});
      rb.query('sortBy', params.sortBy, {});
      rb.query('search', params.search, {});
      rb.query('searchBy', params.searchBy, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPaginatedDocumented & {
        'data'?: Array<WorkDocument>;
        'meta'?: {
        'select'?: Array<string>;
        'filter'?: {
        'folder'?: (string | Array<string>);
        'assignedTo'?: (string | Array<string>);
        'processingStatus'?: (string | Array<string>);
        'users.id'?: (string | Array<string>);
        'projectId'?: (string | Array<string>);
        'prospectId'?: (string | Array<string>);
        'active'?: (string | Array<string>);
        'documenttypeId'?: (string | Array<string>);
        'documenttype.identifierName'?: (string | Array<string>);
        'documentsubtypeId'?: (string | Array<string>);
        'statusId'?: (string | Array<string>);
        'created'?: (string | Array<string>);
        };
        };
        }>;
      })
    );
  }

  /**
   * Required permissions: documents:read, documents:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentsV2ControllerFindAllPaginated$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentsV2ControllerFindAllPaginated(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by folder query param.
     *           <p>
     *              <b>Format: </b> filter.folder={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.folder=$not:$like:John Doe&filter.folder=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.folder'?: Array<string>;

    /**
     * Filter by assignedTo query param.
     *           <p>
     *              <b>Format: </b> filter.assignedTo={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.assignedTo=$not:$like:John Doe&filter.assignedTo=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.assignedTo'?: Array<string>;

    /**
     * Filter by processingStatus query param.
     *           <p>
     *              <b>Format: </b> filter.processingStatus={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.processingStatus=$not:$like:John Doe&filter.processingStatus=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$in</li></ul>
     */
      'filter.processingStatus'?: Array<string>;

    /**
     * Filter by users.id query param.
     *           <p>
     *              <b>Format: </b> filter.users.id={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.users.id=$not:$like:John Doe&filter.users.id=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.users.id'?: Array<string>;

    /**
     * Filter by projectId query param.
     *           <p>
     *              <b>Format: </b> filter.projectId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.projectId=$not:$like:John Doe&filter.projectId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$in</li></ul>
     */
      'filter.projectId'?: Array<string>;

    /**
     * Filter by prospectId query param.
     *           <p>
     *              <b>Format: </b> filter.prospectId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.prospectId=$not:$like:John Doe&filter.prospectId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.prospectId'?: Array<string>;

    /**
     * Filter by active query param.
     *           <p>
     *              <b>Format: </b> filter.active={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.active=$not:$like:John Doe&filter.active=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.active'?: Array<string>;

    /**
     * Filter by documenttypeId query param.
     *           <p>
     *              <b>Format: </b> filter.documenttypeId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.documenttypeId=$not:$like:John Doe&filter.documenttypeId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$in</li>
     * <li>$not</li></ul>
     */
      'filter.documenttypeId'?: Array<string>;

    /**
     * Filter by documenttype.identifierName query param.
     *           <p>
     *              <b>Format: </b> filter.documenttype.identifierName={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.documenttype.identifierName=$not:$like:John Doe&filter.documenttype.identifierName=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$not</li>
     * <li>$null</li></ul>
     */
      'filter.documenttype.identifierName'?: Array<string>;

    /**
     * Filter by documentsubtypeId query param.
     *           <p>
     *              <b>Format: </b> filter.documentsubtypeId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.documentsubtypeId=$not:$like:John Doe&filter.documentsubtypeId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$null</li></ul>
     */
      'filter.documentsubtypeId'?: Array<string>;

    /**
     * Filter by statusId query param.
     *           <p>
     *              <b>Format: </b> filter.statusId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.statusId=$not:$like:John Doe&filter.statusId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$null</li>
     * <li>$not</li></ul>
     */
      'filter.statusId'?: Array<string>;

    /**
     * Filter by created query param.
     *           <p>
     *              <b>Format: </b> filter.created={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.created=$not:$like:John Doe&filter.created=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$gte</li>
     * <li>$lte</li>
     * <li>$btw</li></ul>
     */
      'filter.created'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> upload:DESC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>name</li>
     * <li>upload</li>
     * <li>created</li>
     * <li>documenttype.name</li></ul>
     */
      sortBy?: Array<'name:ASC' | 'name:DESC' | 'upload:ASC' | 'upload:DESC' | 'created:ASC' | 'created:DESC' | 'documenttype.name:ASC' | 'documenttype.name:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> name,prettyName
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>name</li>
     * <li>prettyName</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<WorkPaginatedDocumented & {
'data'?: Array<WorkDocument>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'folder'?: (string | Array<string>);
'assignedTo'?: (string | Array<string>);
'processingStatus'?: (string | Array<string>);
'users.id'?: (string | Array<string>);
'projectId'?: (string | Array<string>);
'prospectId'?: (string | Array<string>);
'active'?: (string | Array<string>);
'documenttypeId'?: (string | Array<string>);
'documenttype.identifierName'?: (string | Array<string>);
'documentsubtypeId'?: (string | Array<string>);
'statusId'?: (string | Array<string>);
'created'?: (string | Array<string>);
};
};
}> {
    return this.documentsV2ControllerFindAllPaginated$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkDocument>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'folder'?: (string | Array<string>);
'assignedTo'?: (string | Array<string>);
'processingStatus'?: (string | Array<string>);
'users.id'?: (string | Array<string>);
'projectId'?: (string | Array<string>);
'prospectId'?: (string | Array<string>);
'active'?: (string | Array<string>);
'documenttypeId'?: (string | Array<string>);
'documenttype.identifierName'?: (string | Array<string>);
'documentsubtypeId'?: (string | Array<string>);
'statusId'?: (string | Array<string>);
'created'?: (string | Array<string>);
};
};
}>): WorkPaginatedDocumented & {
'data'?: Array<WorkDocument>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'folder'?: (string | Array<string>);
'assignedTo'?: (string | Array<string>);
'processingStatus'?: (string | Array<string>);
'users.id'?: (string | Array<string>);
'projectId'?: (string | Array<string>);
'prospectId'?: (string | Array<string>);
'active'?: (string | Array<string>);
'documenttypeId'?: (string | Array<string>);
'documenttype.identifierName'?: (string | Array<string>);
'documentsubtypeId'?: (string | Array<string>);
'statusId'?: (string | Array<string>);
'created'?: (string | Array<string>);
};
};
} => r.body)
    );
  }

  /** Path part for operation `documentsV2ControllerUploadFile()` */
  static readonly DocumentsV2ControllerUploadFilePath = '/v2/documents';

  /**
   * Required permissions: documents:create, documents:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentsV2ControllerUploadFile()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  documentsV2ControllerUploadFile$Response(
    params: {
      body: WorkCreateDocumentV2Dto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkDocument>> {
    const rb = new RequestBuilder(this.rootUrl, WorkDocumentsV2Service.DocumentsV2ControllerUploadFilePath, 'post');
    if (params) {
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkDocument>;
      })
    );
  }

  /**
   * Required permissions: documents:create, documents:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentsV2ControllerUploadFile$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  documentsV2ControllerUploadFile(
    params: {
      body: WorkCreateDocumentV2Dto
    },
    context?: HttpContext
  ): Observable<WorkDocument> {
    return this.documentsV2ControllerUploadFile$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkDocument>): WorkDocument => r.body)
    );
  }

  /** Path part for operation `documentsV2ControllerFindByUserId()` */
  static readonly DocumentsV2ControllerFindByUserIdPath = '/v2/documents/byUserId/{userId}';

  /**
   * Required permissions: documents:read, documents:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentsV2ControllerFindByUserId()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentsV2ControllerFindByUserId$Response(
    params: {
      userId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkDocument>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkDocumentsV2Service.DocumentsV2ControllerFindByUserIdPath, 'get');
    if (params) {
      rb.path('userId', params.userId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkDocument>>;
      })
    );
  }

  /**
   * Required permissions: documents:read, documents:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentsV2ControllerFindByUserId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentsV2ControllerFindByUserId(
    params: {
      userId: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkDocument>> {
    return this.documentsV2ControllerFindByUserId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkDocument>>): Array<WorkDocument> => r.body)
    );
  }

  /** Path part for operation `documentsV2ControllerFindDocuments()` */
  static readonly DocumentsV2ControllerFindDocumentsPath = '/v2/documents/findDocuments';

  /**
   * Required permissions: documents:read, documents:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentsV2ControllerFindDocuments()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentsV2ControllerFindDocuments$Response(
    params?: {

    /**
     * Filter by document ID
     */
      id?: number;

    /**
     * Filter by user ID
     */
      userId?: number;

    /**
     * Filter by project ID
     */
      projectId?: number;

    /**
     * Filter by document type identifier names
     */
      documentTypeNames?: Array<WorkDocumenttypeIdentifierNameEnum>;

    /**
     * Filter by document type IDs
     */
      documentTypeIds?: Array<number>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkDocument>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkDocumentsV2Service.DocumentsV2ControllerFindDocumentsPath, 'get');
    if (params) {
      rb.query('id', params.id, {});
      rb.query('userId', params.userId, {});
      rb.query('projectId', params.projectId, {});
      rb.query('documentTypeNames', params.documentTypeNames, {});
      rb.query('documentTypeIds', params.documentTypeIds, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkDocument>>;
      })
    );
  }

  /**
   * Required permissions: documents:read, documents:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentsV2ControllerFindDocuments$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentsV2ControllerFindDocuments(
    params?: {

    /**
     * Filter by document ID
     */
      id?: number;

    /**
     * Filter by user ID
     */
      userId?: number;

    /**
     * Filter by project ID
     */
      projectId?: number;

    /**
     * Filter by document type identifier names
     */
      documentTypeNames?: Array<WorkDocumenttypeIdentifierNameEnum>;

    /**
     * Filter by document type IDs
     */
      documentTypeIds?: Array<number>;
    },
    context?: HttpContext
  ): Observable<Array<WorkDocument>> {
    return this.documentsV2ControllerFindDocuments$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkDocument>>): Array<WorkDocument> => r.body)
    );
  }

  /** Path part for operation `documentsV2ControllerFindByProjectIdAndDocumentTypeIdentifiers()` */
  static readonly DocumentsV2ControllerFindByProjectIdAndDocumentTypeIdentifiersPath = '/v2/documents/byProjectIdAndDocumentTypeIdentifiers/{projectId}';

  /**
   * Required permissions: documents:read, documents:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentsV2ControllerFindByProjectIdAndDocumentTypeIdentifiers()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentsV2ControllerFindByProjectIdAndDocumentTypeIdentifiers$Response(
    params: {
      projectId: number;
      documentTypeNames: Array<WorkDocumenttypeIdentifierNameEnum>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkDocument>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkDocumentsV2Service.DocumentsV2ControllerFindByProjectIdAndDocumentTypeIdentifiersPath, 'get');
    if (params) {
      rb.path('projectId', params.projectId, {});
      rb.query('documentTypeNames', params.documentTypeNames, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkDocument>>;
      })
    );
  }

  /**
   * Required permissions: documents:read, documents:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentsV2ControllerFindByProjectIdAndDocumentTypeIdentifiers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentsV2ControllerFindByProjectIdAndDocumentTypeIdentifiers(
    params: {
      projectId: number;
      documentTypeNames: Array<WorkDocumenttypeIdentifierNameEnum>;
    },
    context?: HttpContext
  ): Observable<Array<WorkDocument>> {
    return this.documentsV2ControllerFindByProjectIdAndDocumentTypeIdentifiers$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkDocument>>): Array<WorkDocument> => r.body)
    );
  }

  /** Path part for operation `documentsV2ControllerFindByProjectIdAndDocumentTypeIds()` */
  static readonly DocumentsV2ControllerFindByProjectIdAndDocumentTypeIdsPath = '/v2/documents/byProjectIdAndDocumentTypeIds/{projectId}';

  /**
   * Required permissions: documents:read, documents:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentsV2ControllerFindByProjectIdAndDocumentTypeIds()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentsV2ControllerFindByProjectIdAndDocumentTypeIds$Response(
    params: {
      projectId: number;
      typeIds: Array<number>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkDocument>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkDocumentsV2Service.DocumentsV2ControllerFindByProjectIdAndDocumentTypeIdsPath, 'get');
    if (params) {
      rb.path('projectId', params.projectId, {});
      rb.query('typeIds', params.typeIds, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkDocument>>;
      })
    );
  }

  /**
   * Required permissions: documents:read, documents:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentsV2ControllerFindByProjectIdAndDocumentTypeIds$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentsV2ControllerFindByProjectIdAndDocumentTypeIds(
    params: {
      projectId: number;
      typeIds: Array<number>;
    },
    context?: HttpContext
  ): Observable<Array<WorkDocument>> {
    return this.documentsV2ControllerFindByProjectIdAndDocumentTypeIds$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkDocument>>): Array<WorkDocument> => r.body)
    );
  }

  /** Path part for operation `documentsV2ControllerView()` */
  static readonly DocumentsV2ControllerViewPath = '/v2/documents/document/{fileRequestId}/{fileName}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentsV2ControllerView()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentsV2ControllerView$Response(
    params: {
      fileRequestId: string;
      fileName: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkDocumentsV2Service.DocumentsV2ControllerViewPath, 'get');
    if (params) {
      rb.path('fileRequestId', params.fileRequestId, {});
      rb.path('fileName', params.fileName, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentsV2ControllerView$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentsV2ControllerView(
    params: {
      fileRequestId: string;
      fileName: string;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.documentsV2ControllerView$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `documentsV2ControllerDownloadDocuments()` */
  static readonly DocumentsV2ControllerDownloadDocumentsPath = '/v2/documents/download';

  /**
   * Required permissions: documents:read, documents:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentsV2ControllerDownloadDocuments()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentsV2ControllerDownloadDocuments$Response(
    params: {
      ids: Array<number>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkDocumentsV2Service.DocumentsV2ControllerDownloadDocumentsPath, 'get');
    if (params) {
      rb.query('ids', params.ids, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: documents:read, documents:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentsV2ControllerDownloadDocuments$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentsV2ControllerDownloadDocuments(
    params: {
      ids: Array<number>;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.documentsV2ControllerDownloadDocuments$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `documentsV2ControllerMoveDocumentsToNewProject()` */
  static readonly DocumentsV2ControllerMoveDocumentsToNewProjectPath = '/v2/documents/moveDocumentsToNewProject';

  /**
   * Required permissions: documents:update, documents:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentsV2ControllerMoveDocumentsToNewProject()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentsV2ControllerMoveDocumentsToNewProject$Response(
    params: {
      body: WorkUpdateDocumentsMoveToProjectDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkDocumentsV2Service.DocumentsV2ControllerMoveDocumentsToNewProjectPath, 'patch');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: documents:update, documents:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentsV2ControllerMoveDocumentsToNewProject$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentsV2ControllerMoveDocumentsToNewProject(
    params: {
      body: WorkUpdateDocumentsMoveToProjectDto
    },
    context?: HttpContext
  ): Observable<void> {
    return this.documentsV2ControllerMoveDocumentsToNewProject$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `documentsV2ControllerDelete()` */
  static readonly DocumentsV2ControllerDeletePath = '/v2/documents/{id}';

  /**
   * Required permissions: documents:delete, documents:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentsV2ControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentsV2ControllerDelete$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<boolean>> {
    const rb = new RequestBuilder(this.rootUrl, WorkDocumentsV2Service.DocumentsV2ControllerDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }

  /**
   * Required permissions: documents:delete, documents:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentsV2ControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentsV2ControllerDelete(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<boolean> {
    return this.documentsV2ControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `documentsV2ControllerUpdate()` */
  static readonly DocumentsV2ControllerUpdatePath = '/v2/documents/{id}';

  /**
   * Required permissions: documents:update, documents:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentsV2ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentsV2ControllerUpdate$Response(
    params: {
      id: number;
      body: WorkUpdateDocumentV2Dto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkDocument>> {
    const rb = new RequestBuilder(this.rootUrl, WorkDocumentsV2Service.DocumentsV2ControllerUpdatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkDocument>;
      })
    );
  }

  /**
   * Required permissions: documents:update, documents:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentsV2ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentsV2ControllerUpdate(
    params: {
      id: number;
      body: WorkUpdateDocumentV2Dto
    },
    context?: HttpContext
  ): Observable<WorkDocument> {
    return this.documentsV2ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkDocument>): WorkDocument => r.body)
    );
  }

  /** Path part for operation `documentsV2ControllerSaveAnnotation()` */
  static readonly DocumentsV2ControllerSaveAnnotationPath = '/v2/documents/{id}/annotation';

  /**
   * Required permissions: documents:update, documents:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentsV2ControllerSaveAnnotation()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  documentsV2ControllerSaveAnnotation$Response(
    params: {
      id: number;
      body: WorkSaveDocumentAnnotationV2Dto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkDocument>> {
    const rb = new RequestBuilder(this.rootUrl, WorkDocumentsV2Service.DocumentsV2ControllerSaveAnnotationPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkDocument>;
      })
    );
  }

  /**
   * Required permissions: documents:update, documents:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentsV2ControllerSaveAnnotation$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  documentsV2ControllerSaveAnnotation(
    params: {
      id: number;
      body: WorkSaveDocumentAnnotationV2Dto
    },
    context?: HttpContext
  ): Observable<WorkDocument> {
    return this.documentsV2ControllerSaveAnnotation$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkDocument>): WorkDocument => r.body)
    );
  }

  /** Path part for operation `documentsV2ControllerRotate()` */
  static readonly DocumentsV2ControllerRotatePath = '/v2/documents/{id}/rotate/{counterclockwise}';

  /**
   * Required permissions: documents:update, documents:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentsV2ControllerRotate()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentsV2ControllerRotate$Response(
    params: {
      id: number;
      counterclockwise: boolean;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkDocumentsV2Service.DocumentsV2ControllerRotatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.path('counterclockwise', params.counterclockwise, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: documents:update, documents:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentsV2ControllerRotate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentsV2ControllerRotate(
    params: {
      id: number;
      counterclockwise: boolean;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.documentsV2ControllerRotate$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `documentsV2ControllerPdfInfo()` */
  static readonly DocumentsV2ControllerPdfInfoPath = '/v2/documents/{id}/pdf-info';

  /**
   * Required permissions: documents:create, documents:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentsV2ControllerPdfInfo()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentsV2ControllerPdfInfo$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkDocumentPdfInfoDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkDocumentsV2Service.DocumentsV2ControllerPdfInfoPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkDocumentPdfInfoDto>;
      })
    );
  }

  /**
   * Required permissions: documents:create, documents:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentsV2ControllerPdfInfo$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentsV2ControllerPdfInfo(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkDocumentPdfInfoDto> {
    return this.documentsV2ControllerPdfInfo$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkDocumentPdfInfoDto>): WorkDocumentPdfInfoDto => r.body)
    );
  }

  /** Path part for operation `documentsV2ControllerSplit()` */
  static readonly DocumentsV2ControllerSplitPath = '/v2/documents/{id}/split';

  /**
   * Required permissions: documents:create, documents:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentsV2ControllerSplit()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentsV2ControllerSplit$Response(
    params: {
      id: number;
      body: WorkSplitDocumentDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkDocument>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkDocumentsV2Service.DocumentsV2ControllerSplitPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkDocument>>;
      })
    );
  }

  /**
   * Required permissions: documents:create, documents:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentsV2ControllerSplit$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentsV2ControllerSplit(
    params: {
      id: number;
      body: WorkSplitDocumentDto
    },
    context?: HttpContext
  ): Observable<Array<WorkDocument>> {
    return this.documentsV2ControllerSplit$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkDocument>>): Array<WorkDocument> => r.body)
    );
  }

  /** Path part for operation `documentsV2ControllerMerge()` */
  static readonly DocumentsV2ControllerMergePath = '/v2/documents/merge';

  /**
   * Required permissions: documents:create, documents:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentsV2ControllerMerge()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentsV2ControllerMerge$Response(
    params: {
      body: WorkMergeDocumentsDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkDocument>> {
    const rb = new RequestBuilder(this.rootUrl, WorkDocumentsV2Service.DocumentsV2ControllerMergePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkDocument>;
      })
    );
  }

  /**
   * Required permissions: documents:create, documents:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentsV2ControllerMerge$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentsV2ControllerMerge(
    params: {
      body: WorkMergeDocumentsDto
    },
    context?: HttpContext
  ): Observable<WorkDocument> {
    return this.documentsV2ControllerMerge$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkDocument>): WorkDocument => r.body)
    );
  }

  /** Path part for operation `documentsV2ControllerBatchDelete()` */
  static readonly DocumentsV2ControllerBatchDeletePath = '/v2/documents/batchDelete';

  /**
   * Required permissions: documents:delete, documents:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentsV2ControllerBatchDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentsV2ControllerBatchDelete$Response(
    params: {
      ids: Array<number>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkDocumentsV2Service.DocumentsV2ControllerBatchDeletePath, 'delete');
    if (params) {
      rb.query('ids', params.ids, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: documents:delete, documents:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentsV2ControllerBatchDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentsV2ControllerBatchDelete(
    params: {
      ids: Array<number>;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.documentsV2ControllerBatchDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `documentsV2ControllerSendDocumentsByEmail()` */
  static readonly DocumentsV2ControllerSendDocumentsByEmailPath = '/v2/documents/sendDocumentsByEmail';

  /**
   * Required permissions: documents:read, documents:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentsV2ControllerSendDocumentsByEmail()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentsV2ControllerSendDocumentsByEmail$Response(
    params: {
      body: WorkSendDocumentsByEmailV2Dto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkDocumentsV2Service.DocumentsV2ControllerSendDocumentsByEmailPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: documents:read, documents:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentsV2ControllerSendDocumentsByEmail$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentsV2ControllerSendDocumentsByEmail(
    params: {
      body: WorkSendDocumentsByEmailV2Dto
    },
    context?: HttpContext
  ): Observable<void> {
    return this.documentsV2ControllerSendDocumentsByEmail$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
